export class NotificationSystemContext {
    public countRoutesToCalculate: number = 0;
    public countRoutesInCalculation: number = 0;
    public countNotGeocodedLocations: number = 0;
    public pendingCalculationsCounters: any = null;
}
